import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (!_ctx.$vuetify.display.mobile)
    ? (_openBlock(), _createBlock(_component_oss_dialog, {
        key: 0,
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
        title: 
            _ctx.$t('chat.createBTChatMessage.title', _ctx.bankTransactions.length, {
                count: _ctx.bankTransactions.length,
            })
        ,
        "min-width": "1200px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_list_item, {
                border: "",
                class: "oss-list-item mb-2 rounded-xl px-4 py-3"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn_next, {
                    loading: _ctx.createBankTransactionMessageLoading,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createBankTransactionMessage()))
                  }, null, 8, ["loading"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("Demande générale")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.bankTransactionMessage,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bankTransactionMessage) = $event)),
                    label: "Message",
                    "single-line": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_list_item, {
                border: "",
                class: "oss-list-item mb-2 rounded-xl px-4 py-3"
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_v_btn_next, {
                    loading: _ctx.createBankTransactionInvoiceMessageLoading,
                    onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.createBankTransactionMessage(true)), ["stop"]))
                  }, null, 8, ["loading"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Demande de facture uniquement")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_text_field_filled, {
                    modelValue: _ctx.bankTransactionInvoiceMessage,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bankTransactionInvoiceMessage) = $event)),
                    label: "Message",
                    "single-line": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "title"]))
    : _createCommentVNode("", true)
}